/* istanbul ignore file */
/* tslint:disable */
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { Job, ResultDataGetTaskResultGetAll } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
import { makeResponses } from '../response_factory';
const makeResult = coreUtils.makeResult;
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function taskResult(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, 
        /* #__PURE__ */ parseJsonResponse(ResultDataGetTaskResultGetAll)),
    });
    const getResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(config, /* #__PURE__ */ parseJsonResponse(Job)),
    });
    const restartResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    const revokeResponse = /* #__PURE__ */ makeResponses({
        204: /* #__PURE__ */ makeResult(config, () => Promise.resolve(null)),
    });
    return Object.freeze({
        /**
         * Get all active tasks, all tasks that have not yet been started, a page of finished tasks, and the total number of finished tasks.
         *
         * @param arg The arguments to the function.
         * @param arg.offset First finished task to get.
         * @param arg.limit Amount of finished tasks to get.
         * @returns The requested tasks, with the given limits applied to the finished jobs.
         */
        getAll: async ({ offset = undefined, limit = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/tasks/`, getAllResponse.v, undefined, {
                offset,
                limit,
            });
            return result;
        },
        /**
         * Get the state of a task result.
         *
         * To check if the task failed you should use the `state` attribute of the returned object as the status code of the response will still be 200. It is 200 as we successfully fulfilled the request, which was getting the task result.
         *
         * @param arg The arguments to the function.
         * @param arg.taskResultId The task result to get.
         * @returns The retrieved task result.
         */
        get: async ({ taskResultId, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/task_results/${taskResultId}`, getResponse.v, undefined);
            return result;
        },
        /**
         * Restart a task result.
         *
         * The restarted task must not be in the `not_started`, `started`, or `finished` state.
         *
         * @param arg The arguments to the function.
         * @param arg.taskResultId The task result to restart.
         * @returns Nothing.
         */
        restart: async ({ taskResultId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/tasks/${taskResultId}/restart`, restartResponse.v, undefined);
            return result;
        },
        /**
         * Revoke a task result.
         *
         * The revoked task must be in the "not_started" state.
         *
         * @param arg The arguments to the function.
         * @param arg.taskResultId The task result to revoke.
         * @returns Nothing.
         */
        revoke: async ({ taskResultId, }) => {
            const result = await requestParams(config, 'POST', `/api/v1/tasks/${taskResultId}/revoke`, revokeResponse.v, undefined);
            return result;
        },
    });
}
